import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useI18n } from '@modules/i18n/composables';
import { useCurrentNamespace } from '@modules/permissions/composables';
import {
  PROFILE_SETTINGS_PERMISSIONS,
  TRANSLATION_GROUP_ADMIN_PROFILE_SETTINGS,
  TRANSLATION_GROUP_AFFILIATE_PROFILE_SETTINGS,
} from '@modules/profile-settings/constants';
import { useToastStore } from '@modules/toast/store';

import type {
  IProfileSettingsChangeEmailPayload,
} from '../types';
import {
  ADMIN_PROFILE_SETTINGS_CHANGE_EMAIL_SAVE_URL,
  AFFILIATE_PROFILE_SETTINGS_CHANGE_EMAIL_SAVE_URL,
  PROFILE_SETTINGS_CHANGE_EMAIL_SAVE_MUTATION_KEY,
} from '../constants';

export default function useProfileSettingsChangeEmailMutation(): IContextMutationResult<
  void,
  Error,
  IProfileSettingsChangeEmailPayload
> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();
  const { isAdminNamespace } = useCurrentNamespace();
  const { getTranslation } = useI18n();

  return useContextMutation<void, Error, IProfileSettingsChangeEmailPayload>({
    mutationKey: [PROFILE_SETTINGS_CHANGE_EMAIL_SAVE_MUTATION_KEY],
    mutationFn: (payload) => fetchPut<void>(
      isAdminNamespace.value ? ADMIN_PROFILE_SETTINGS_CHANGE_EMAIL_SAVE_URL : AFFILIATE_PROFILE_SETTINGS_CHANGE_EMAIL_SAVE_URL,
      payload,
      {
        permission: PROFILE_SETTINGS_PERMISSIONS.EDIT,
      },
    ),
    onSuccess() {
      const translationGroup = isAdminNamespace.value ? TRANSLATION_GROUP_ADMIN_PROFILE_SETTINGS : TRANSLATION_GROUP_AFFILIATE_PROFILE_SETTINGS;
      displayPresetToast('success', getTranslation(translationGroup, 'CHECK_MAILBOX_MESSAGE').value);
    },
  });
}
